module.exports = __webpack_public_path__ + "static/api-0abde955857e608d8456bb1db6b6b8e3.svg";